export default __webpack_public_path__ + "static/media/placeholder_business05-en-web.18fc21fe.png";